/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryPeopleStateCounts,
  DirectoryPeopleStateCounts$inboundSchema,
} from "./directorypeoplestatecounts.js";
import {
  DirectoryPerson,
  DirectoryPerson$inboundSchema,
} from "./directoryperson.js";

export type ListDirectoryPeopleResult = {
  counts: DirectoryPeopleStateCounts;
  /**
   * Cursor for the next page. Absent on the last page.
   */
  nextCursor?: string | undefined;
  /**
   * One page of directory profiles, ordered by profile ID.
   */
  people: Array<DirectoryPerson>;
};

/** @internal */
export const ListDirectoryPeopleResult$inboundSchema: z.ZodMiniType<
  ListDirectoryPeopleResult,
  unknown
> = z.pipe(
  z.object({
    counts: DirectoryPeopleStateCounts$inboundSchema,
    next_cursor: z.optional(z.string()),
    people: z.array(DirectoryPerson$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listDirectoryPeopleResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDirectoryPeopleResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDirectoryPeopleResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDirectoryPeopleResult' from JSON`,
  );
}
